import { composeCouponRouteTemplate } from '@/lib/coupon/gen-code'
import { DEFAULT_AMOUNT_COUPON } from '@/providers/coupon/AmountFormProvider'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/coupon/amount')(
  composeCouponRouteTemplate(DEFAULT_AMOUNT_COUPON),
)
